import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LessonPlanDocumentType, LessonPlanType } from '../../../types/LessonPlan';

const initialState:LessonPlanType = {

}

const lessonPlanSlice = createSlice({
  name: "lessonPlanForm",
  initialState,
  reducers: {
    setLessonPlanData:(state, action:PayloadAction<LessonPlanType>)=>({...state, ...action.payload}), 
    resetLessonPlanData :()=>({...initialState}),
    setLessonPlanDocumentsData: (
        state, action: PayloadAction<LessonPlanDocumentType[]>
      ) => {
        state.documents = action.payload;
      },
    resetLessonPlanDocumentsData: (
        state
      ) => {
        state.documents =[];
      },
  }
});

export const {setLessonPlanData,resetLessonPlanData, setLessonPlanDocumentsData, resetLessonPlanDocumentsData } = lessonPlanSlice.actions

export default lessonPlanSlice.reducer